// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsonCodec from "../primitives/JsonCodec.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";

let codec = JsonCodec.object1(param => param.items, items => ({
  TAG: "Ok",
  _0: {
    items: items
  }
}), JsonCodec.field("items", JsonCodec.array(JsonCodec.string)));

function encode(state) {
  return JsonCodec.encodeWith(state, codec);
}

function decode(historyState) {
  return Stdlib_Option.flatMap(historyState, json => {
    let value = JsonCodec.decodeWith(json, codec);
    if (value.TAG === "Ok") {
      return value._0;
    }
  });
}

export {
  codec,
  encode,
  decode,
}
/* codec Not a pure module */
